import { useState, useRef, useEffect } from 'react';
import { useI18n, languageNames, languageFlags } from '../i18n/index.jsx';

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative', zIndex: 100 }}>
      {/* Trigger button */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          padding: '6px 10px',
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 8,
          color: '#fff',
          fontSize: 13,
          cursor: 'pointer',
          transition: 'all 0.2s',
          minWidth: 0,
        }}
      >
        <span style={{ fontSize: 16 }}>{languageFlags[lang]}</span>
        <span style={{ fontWeight: 600 }}>{lang.toUpperCase()}</span>
        <span style={{
          fontSize: 10,
          opacity: 0.5,
          transform: open ? 'rotate(180deg)' : 'rotate(0)',
          transition: 'transform 0.2s',
        }}>▼</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 4px)',
          right: 0,
          background: '#1a1a2e',
          border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: 10,
          overflow: 'hidden',
          boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
          minWidth: 160,
          animation: 'fadeIn 0.15s ease',
        }}>
          {languages.map(l => (
            <button
              key={l}
              onClick={() => { setLang(l); setOpen(false); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                padding: '10px 14px',
                background: lang === l ? 'rgba(99,102,241,0.2)' : 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: 14,
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'background 0.15s',
                borderLeft: lang === l ? '3px solid #6366f1' : '3px solid transparent',
              }}
              onMouseEnter={e => { if (lang !== l) e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
              onMouseLeave={e => { if (lang !== l) e.currentTarget.style.background = 'transparent'; }}
            >
              <span style={{ fontSize: 18 }}>{languageFlags[l]}</span>
              <span style={{ fontWeight: lang === l ? 600 : 400 }}>
                {languageNames[l]?.replace(/^.\s/, '') || l}
              </span>
              {lang === l && <span style={{ marginLeft: 'auto', fontSize: 12, color: '#6366f1' }}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
